import React, {Fragment, useEffect} from 'react';

import '../../App.css';
import {Button, Flex, Segmented, Space, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDiagramProject, faEarthAmericas, faGear, faGrip, faList, faPlus} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import {Story} from "../../feature/project/story";
import {AddStoryModal} from "../story/AddStoryModal";
import {resetStatus, saveStory} from "../../feature/project/storySlice";
import {useCookies} from "react-cookie";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {ViewMode} from "../common/ViewMode";
import {Stories} from "../story/Stories";
import Title from "antd/es/typography/Title";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";

const ProjectDetails = () => {
    const dispatch = useAppDispatch()
    const [cookies, setCookie] = useCookies(['storyView']);
    const {projectId} = useParams();
    const project = useAppSelector(state => state.projects.project);
    const navigate = useNavigate();
    const [modal, setModal] = React.useState(false)

    useEffect(() => {
        dispatch(resetStatus())
    }, [project, dispatch])

    return (
        <Fragment>
            <Flex justify={'space-between'}>

                <Space>
                    <Title level={4} style={{margin: 0}}>Stories</Title>

                </Space>
                <Space>
                    <WithUserPermission roles={editorRoles}>
                        <Tooltip title="Add Story">
                            <Button icon={<FontAwesomeIcon icon={faPlus}/>} onClick={() => setModal(true)}>Add
                                Story</Button>
                        </Tooltip>
                    </WithUserPermission>
                    <Segmented
                        options={[
                            {
                                value: 'list',
                                icon: <Tooltip title="List View"><FontAwesomeIcon icon={faList}/></Tooltip>
                            },
                            {
                                value: 'grid',
                                icon: <Tooltip title="Grid View"><FontAwesomeIcon icon={faGrip}/></Tooltip>
                            },
                            {
                                value: 'graph',
                                icon: <Tooltip title="GraphsContent View"><FontAwesomeIcon
                                    icon={faDiagramProject}/></Tooltip>
                            },
                        ]}
                        onChange={(value) => setCookie('storyView', value)}
                        value={cookies['storyView'] || 'list'}
                    />
                    <Tooltip title="Global Lore">
                        <Button onClick={() => navigate(`/projects/${projectId}/setting`)}
                                icon={<FontAwesomeIcon icon={faEarthAmericas}/>}>Global Lore</Button>
                    </Tooltip>
                </Space>
            </Flex>
            <Stories viewMode={cookies['storyView'] === ViewMode.List ? ViewMode.List : ViewMode.Grid}/>
            <AddStoryModal
                story={{title: '', description: '', cover: '', tags: []}}
                visible={modal}
                onCancel={() => setModal(false)}
                onSave={(story: Story) => {
                    if (project) {
                        dispatch(saveStory({projectId: project.id, story: story}))
                    }
                    setModal(false)
                }}
            />
        </Fragment>
    );
};

export default ProjectDetails;